<script setup>
import Section from '@/components/Section.vue';
import {onMounted, ref} from 'vue';
import { render } from './tools';
import Wrapper from '@/components/Wrapper.vue';

const container = ref(null);



onMounted(() => {
    if (container.value) {
        render(container.value);
    }
});
</script>

<template>
    <Section id="benefits">
        <h1>
            Benefits of taking action
        </h1>
        <h2>
            <span>
                How would the proposed Clean Air Policy Package improve health, the economy and the environment?
            </span>
        </h2>

        <Wrapper>
            <div class="illustration">
                <img src="/economy.png" alt="" />
            </div>
            <div class="container" ref="container" />
        </Wrapper>
    </Section>
</template>


<style lang="scss" scoped>
.container {
    height: 700px;
}

.illustration {
    position: absolute;
    left: 0;
    bottom: 48px;
    z-index: 1;
}
</style>

<style lang="scss">
.benefits-header {
    fill: #004A7A;
    font-size: 18px;
}

.benefits-kills {
    fill: #31B5AD;
}

.benefits-kills.benefits-survived {
    fill: #fff;
}

.benefits-expectancy-rect {
    stroke-width: 1px;
    stroke: #fff;
    fill: none;
}

.benefits-expectancy-rect-filled {
    stroke-width: 1px;
    stroke: #fff;
    fill: #31B5AD;
}

.benefits-expectancy-rect-filled-white {
    fill: #fff;
    opacity: 0.5;
}

.benefits-economy-circle-passive {
    fill: rgba(49,181,173,0.2);
}

.benefits-economy-circle {
    fill: rgba(49,181,173,1);
}

.benefits-perc {
    fill: #004A7A;
    font-size: 13.5px;
    font-weight: 700;
}
</style>
